import {
    WAREHOUSE_LOADING,
    WAREHOUSE_SET,
    WAREHOUSE_ERROR,
    WAREHOUSE_ADD,
    WAREHOUSE_SHOW,
    WAREHOUSE_DELETE,
    WAREHOUSE_UPDATE,
    WAREHOUSE_RESET,
    WAREHOUSE_EDIT,
} from './warehouseActions'


const initialState = {
    loading: false,
    data: [],
    error: null,
    success: null,
    idEdit: null,
    idxShow: null,
}

const warehouseReducer = (state = initialState, { payload, type }) => {

    switch (type) {
        case WAREHOUSE_LOADING:
            return {
                ...state,
                loading: true,
            }
        case WAREHOUSE_UPDATE:
            return {
                ...state,
                loading: false,
                data: state.data.map(x => x.id === state.idEdit ? payload : x),
                success: 'Data has been updated successfully.'
            }
        case WAREHOUSE_SET:
            return {
                ...state,
                error: null,
                loading: false,
                data: payload
            }
        case WAREHOUSE_ADD:
            return {
                ...state,
                loading: false,
                error: null,
                data: [payload, ...state.data],
                success: 'New warehouse has been added successfully.'
            }
        case WAREHOUSE_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            }
        case WAREHOUSE_SHOW:
            return {
                ...state,
                idxShow: payload,
                success: null,
                error: null
            }
        case WAREHOUSE_RESET:
            return {
                ...state,
                error: null,
                success: null,
            }
        case WAREHOUSE_EDIT:
            return {
                ...state,
                error: null,
                success: null,
                idEdit: payload
            }
        case WAREHOUSE_DELETE:
            return {
                ...state,
                success: 'Data has been deleted successfully',
                data: state.data.filter(a => !payload.includes(a.id)),
                loading: false,
            }
        default:
            return state;
    }
}

export default warehouseReducer